/**
 * 共通処理
 */

import * as constants from "@/mixin/constants";

var platform = require("platform");

export default {
  data() {
    return {
      scrollY: 0 //現在のスクロール量
    };
  },
  methods: {
    /**
     * ログ出力
     */
    log: function(message) {
      // 開発環境のときだけ、ログ出力
      var env = process.env.DEPLOY_ENV;
      if (env !== "production") {
        console.log(message);
      }
    },
    /**
     * スコア情報を分割する
     * 配列0番: levelNo
     * 配列1番: unitNo
     * 配列2番: lesson index
     * 配列3番: path index
     * 配列4番: pathStep index
     * 配列5番: "ok" or "ng" or "skip"
     */
    splitScore: function(score) {
      var res = [];

      var key = Object.keys(score);
      var split = key[0].split("-");
      if (split.length != 8) {
        return res;
      }

      res.push(
        Number(split[2]),
        Number(split[3]),
        Number(split[4]),
        Number(split[5]),
        Number(split[6]),
        split[7]
      );
      return res;
    },
    /**
     * 進捗情報を分割する
     * 配列0番: levelNo
     * 配列1番: unitNo
     * 配列2番: lesson index
     * 配列3番: path index
     */
    splitProgress: function(progress) {
      var res = [];

      var key = Object.keys(progress);
      var split = key[0].split("-");
      if (split.length != 6) {
        return res;
      }

      res.push(
        Number(split[2]),
        Number(split[3]),
        Number(split[4]),
        Number(split[5])
      );
      return res;
    },
    /**
     * JSONのlevelNoとnumberが一致するデータを取得
     */
    getLevelJson: function(jsonData, number) {
      var res = null;

      for (var level of jsonData.levels) {
        if (level.levelNo == number) {
          res = level;
          break;
        }
      }
      return res;
    },
    /**
     * JSONのlevelNoとnumberが一致するデータのindexを取得
     */
    getLevelIndex: function(jsonData, number) {
      var res = -1;

      for (var [index, level] of jsonData.levels.entries()) {
        if (level.levelNo == number) {
          res = index;
          break;
        }
      }
      return res;
    },
    /**
     * JSONのunitNoとnumberが一致するデータを取得
     */
    getUnitJson: function(levelJson, number) {
      var res = null;

      for (var unit of levelJson.units) {
        if (unit.unitNo == number) {
          res = unit;
          break;
        }
      }
      return res;
    },
    /**
     * JSONのunitNoとnumberが一致するデータのindexを取得
     */
    getUnitIndex: function(levelJson, number) {
      var res = -1;

      for (var [index, unit] of levelJson.units.entries()) {
        if (unit.unitNo == number) {
          res = index;
          break;
        }
      }
      return res;
    },
    /**
     * マイルストーンデータを作成
     */
    createMilestone: function(unitJson, levelNo, unitNo) {
      var createData = { data: [] };
      var createMode = [];
      var loopCount = 0;

      while (createData.data.length < constants.MILESTONE_QUESTION_COUNT) {
        // 各indexを取得
        var lessonIndex = this.getLessonIndexByRandom(unitJson);

        var lessonsJson = unitJson.lessons[lessonIndex];
        var pathIndex = this.getPathIndexByCore(lessonsJson);

        var pathJson = lessonsJson.paths[pathIndex];
        var pathstepIndex = this.getPathstepIndexByRandom(pathJson);

        // すでに同じ問題が抽出されていないか確認
        var sameDataFlag = this.isSameData(
          createData.data,
          lessonIndex,
          pathIndex,
          pathstepIndex
        );
        if (sameDataFlag) {
          continue;
        }

        // すでに同じmodeがあるか確認
        var mode = pathJson.pathsteps[pathstepIndex].mode;
        var sameModeFlag = this.isSameMode(createMode, mode);
        if (!sameModeFlag) {
          var param = {
            lessonIndex: lessonIndex,
            pathIndex: pathIndex,
            pathstepIndex: pathstepIndex
          };
          createData.data.push(param);
          createMode.push(mode);
        } else {
          // 最大60回繰り返す(レッスンは4つ、コアレッスンは15問なので60回)
          if (loopCount == 60) {
            var param = {
              lessonIndex: lessonIndex,
              pathIndex: pathIndex,
              pathstepIndex: pathstepIndex
            };
            createData.data.push(param);
            createMode.push(mode);
            loopCount = 0;
          } else {
            loopCount++;
          }
        }
      }

      // 整形
      var result = [];
      for (var data of createData.data) {
        var str =
          levelNo +
          "-" +
          unitNo +
          "-" +
          data.lessonIndex +
          "-" +
          data.pathIndex +
          "-" +
          data.pathstepIndex;
        result.push(str);
      }

      return result;
    },
    /**
     * ランダムでlessonIndexを取得
     */
    getLessonIndexByRandom: function(unitJson) {
      //  マイルストーンを含めないため-1する
      var lessonLen = unitJson.lessons.length - 1;
      var lessonIndex = Math.floor(Math.random() * lessonLen);
      return lessonIndex;
    },
    /**
     * コアレッスンのpathIndexを取得
     */
    getPathIndexByCore: function(lessonJson) {
      var pathIndex = 0;
      for (var i = 0; i < lessonJson.paths.length; i++) {
        if (lessonJson.paths[i].title === constants.MILESTONE_TARGET_TITLE) {
          pathIndex = i;
          break;
        }
      }
      return pathIndex;
    },
    /**
     * ランダムでpathstepIndexを取得
     */
    getPathstepIndexByRandom: function(pathJson) {
      var pathstepLen = pathJson.pathsteps.length;
      var pathstepIndex = Math.floor(Math.random() * pathstepLen);
      return pathstepIndex;
    },
    /**
     * 同じデータがあるか確認
     */
    isSameData: function(data, lessonIndex, pathIndex, pathstepIndex) {
      var res = false;
      for (var item of data) {
        if (item.lessonIndex == lessonIndex) {
          if (item.pathIndex == pathIndex) {
            if (item.pathstepIndex == pathstepIndex) {
              res = true;
              break;
            }
          }
        }
      }
      return res;
    },
    /**
     * 同じmodeがあるか確認
     */
    isSameMode: function(data, mode) {
      var filter = data.filter(function(element, index, array) {
        if (element === mode) {
          return true;
        }
      });

      if (filter.length == 0) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * マイク一覧取得
     *
     * @return {Promise} resolve:有効なマイクオブジェクト一覧
     */
    getMicrophones: function() {
      var result = [];
      return new Promise(function(resolve) {
        switch (platform.name) {
          case "Chrome":
            navigator.mediaDevices
              .enumerateDevices()
              .then(function(devices) {
                for (var device of devices) {
                  if (
                    device.kind == "audioinput" &&
                    device.deviceId != "default" &&
                    device.deviceId != "communications"
                  ) {
                    result.push({ name: device.label, id: device.deviceId });
                  }
                }
                resolve(result);
              })
              .catch(function(err) {
                this.log(err.name + ": " + err.message);
                resolve(result);
              });
            break;
          default:
            resolve(result);
            break;
        }
      });
    },
    /**
     * マイク設定要否を返す
     *
     * @param {Object} current マイクオブジェクト
     * @return {Boolean} true:要設定, false:設定不要
     */
    needsMicrophoneSetting: async function(current) {
      switch (platform.name) {
        case "Chrome":
          var microphones = await this.getMicrophones();
          return microphones.every(function(microphone) {
            return !current || microphone.id != current.id;
          });
        // Chrome以外のブラウザでは判定できない
        default:
          return false;
      }
    },
    /**
     * SREの設定情報をログ出力
     */
    outputLogSonicSettings: function() {
      this.log(platform.description);
      if (window.hasOwnProperty("Phone")) {
        return;
      }
      this.log("SRE version : " + speechEngine.getVersion());
      var model = speechEngine.getConfiguredModelDescriptor();
      var language = model.getLanguage();
      var voiceType = model.getVoiceType();
      var difficulty = speechEngine.getConfiguredDifficulty();
      this.log(
        "SRE configured for " +
          language +
          ", " +
          voiceType +
          " (difficulty " +
          difficulty +
          ")"
      );
    },
    /**
     * Safariの問題画面ブラウザ縮小時の高さ調整
     */
    fixtHeightForSafari: function(contentHeight) {
      var windowHeight = window.innerHeight;
      $("body").css("height", "100vh");
      $(".page-content").css("height", windowHeight - contentHeight + "px");

      $(window).resize(function() {
        var windowHeight = window.innerHeight;
        $("body").css("height", "100vh");
        $(".page-content").css("height", windowHeight - contentHeight + "px");
      });
    },
    /**
     * Safariのログイン、シリアル、ローディング画面のブラウザ縮小時の高さ調整
     */
    fixtHeightForSafariFullWindow: function() {
      var windowHeight = window.innerHeight;
      $("body").css("height", windowHeight + "px");
      $(".inner.flexcenter").css("height", windowHeight + "px");

      $(window).resize(function() {
        var windowHeight = window.innerHeight;
        $("body").css("height", windowHeight + "px");
        $(".inner.flexcenter").css("height", windowHeight + "px");
      });
    },
    /**
     * 実行環境がPCの場合trueを返却する
     */
    isEnvironmentPc: function() {
      var p = window.hasOwnProperty("Phone");
      if (p) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 実行環境がモバイルアプリの場合、bodyにclass'modal-open'を追加する
     * モーダル画面表示中はスクロール不可にするため
     *
     * @param {Boolean} add trueの場合は追加、falseの場合は削除
     */
    setBodyStylePosition: function(add) {
      var p = window.hasOwnProperty("Phone");
      if (!p) {
        // PCの場合、何もしない
        return;
      }

      if (add) {
        scrollY = window.pageYOffset;
        document.getElementsByTagName("body")[0].classList.add("modal-open");
        document.body.style.top = -1 * scrollY + "px";
      } else {
        document.getElementsByTagName("body")[0].classList.remove("modal-open");
        document.body.style.top = "";
        window.scrollTo(0, scrollY);
      }
    },
    /**
     * Flash版実行強制フラグを取得する
     *
     * @return {Boolean} true：Flash版で動作させる、false：左記以外
     */
    isForceFlash: function() {
      if (this.isEnvironmentPc()) {
        switch (platform.name) {
          case "IE":
            // IEはFlash版で動作させる
            return true;
          case "Safari":
            // Safariはブラウザバージョンによって判定
            var version = platform.version;
            var major = Number(version.substring(0, version.indexOf(".")));
            return major < constants.SAFARI_HTML5_VERSION;
          default:
            // 上記以外はSREが判断する
            return false;
        }
      } else {
        // モバイルアプリ版
        return false;
      }
    },
    /**
     * 単語リストの取得
     *
     * @param {Object} pathstep 現在出題中のPathstep一覧情報
     *
     * @return {Array} 取得した単語リスト
     */
    getDictionaryWordList: function(pathstep) {
      var self = this;
      var wordList = [];
      var tempWordList = [];
      var acts = pathstep.acts;

      acts.forEach(function(actInfo) {
        // HTMLタグを除去し、選択肢と選択肢以外に分ける
        var textList = self
          .tagErase(actInfo.basicText)
          .replace(/\[/g, "####[")
          .replace(/\]/g, "]####")
          .split("####");
        textList.forEach(function(text) {
          var match = text.match(/\[([^\]]*)\]/g);
          if (match) {
            // 選択肢の場合
            match.forEach(function(choice) {
              choice = choice.replace(/\[|\]/g, "").split("/");
              choice.forEach(function(word) {
                tempWordList = tempWordList.concat(word.split(/\s/));
              });
            });
          } else {
            // 選択肢以外
            tempWordList = tempWordList.concat(text.split(/\s/));
          }
        });
      });
      tempWordList.forEach(function(word) {
        // 英字と'と-以外の文字を除去
        word = word.replace(/[^a-zA-Z'’-]/g, "");
        if (!self.isSameValue(wordList, word)) {
          wordList.push(word);
        }
      });
      return wordList;
    },
    /**
     * HTMLタグを除去する
     *
     * @param {String} str HTML除去対象の文字列
     *
     * @return {String} HTMLタグ除去後の文字列
     */
    tagErase: function(str) {
      return str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
    },
    /**
     * 配列内に同じ値があるかを判定する
     *
     * @param {Array} list 判定対象の配列
     * @param {String} value 判定対象の文字列
     *
     * @return {Boolean} true: 同じ値がある, false: 同じ値がない
     */
    isSameValue: function(list, value) {
      var result = true;

      if (value.length == 0) {
        return result;
      }

      result = list.some(function(data) {
        var lowData = data.toLowerCase();
        var lowValue = value.toLowerCase();
        return lowData === lowValue;
      });

      return result;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/common.js